module.exports = __webpack_public_path__ + "img/vipPost.94ab43af.png";